import { Platform } from 'react-native';

let storageInstance: any;

// MMKV is not supported on Web, so we use a Polyfill with localStorage
if (Platform.OS === 'web') {
    storageInstance = {
        set: (key: string, value: string | boolean | number) => {
            if (typeof value === 'boolean' || typeof value === 'number') {
                localStorage.setItem(key, value.toString());
            } else {
                localStorage.setItem(key, value);
            }
        },
        getString: (key: string) => {
            return localStorage.getItem(key) || undefined;
        },
        getBoolean: (key: string) => {
            return localStorage.getItem(key) === 'true';
        },
        getNumber: (key: string) => {
            const value = localStorage.getItem(key);
            return value ? Number(value) : 0;
        },
        delete: (key: string) => {
            localStorage.removeItem(key);
        },
        clearAll: () => {
            localStorage.clear();
        },
        contains: (key: string) => {
            return localStorage.getItem(key) !== null;
        },
        getAllKeys: () => {
            return Object.keys(localStorage);
        }
    };
} else {
    // Native implementation using MMKV v4.x with Nitro Modules
    try {
        const { createMMKV } = require('react-native-mmkv');
        storageInstance = createMMKV({
            id: 'amar-dairy-farm-storage',
            encryptionKey: 'amar-dairy-secure-key'
        });
    } catch (e) {
        console.error('Failed to initialize MMKV:', e);
        // Fallback for when basic require fails (though it shouldn't on native)
        storageInstance = {
            set: () => { },
            getString: () => undefined,
            delete: () => { },
            clearAll: () => { },
        };
    }
}

// Create a single MMKV instance for the app
export const storage = storageInstance;

/**
 * Storage keys
 */
export const STORAGE_KEYS = {
    TOKEN: 'auth.token',
    USER: 'auth.user',
    SECURE_USERNAME: 'secure.username',
    SECURE_PASSWORD: 'secure.password'
};
